import React, { PureComponent, memo } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import '../CambiarContrasena/CambiarContrasenaPage.css';
import { SiteRutas, ImagenesRutas } from '../../request/RutasConfig';
import { Cambiar_Pin_Request } from '../../request/LoginRequest';
import { Notificacion } from '../../components/Util/Notificacion/Notificacion';
import { establecerUsuarioConectado } from '../../store/usuario/actions';

class CambiarPinPage extends PureComponent {
    state = {
        currentPass: '',
        newPass: '',
        confirmPass: ''
    }
        
    

    onChangeInput = event => {
        const { name, value } = event.target;
        if (name != "currentPass") {

            if (isNaN(value)) {
                Notificacion.error("Solo se aceptan valores numéricos.");
                return;  
            } else {
                this.setState({ [name]: value });
            }
        }
        else
            this.setState({ [name]: value });
    }

    onClickBtnCancel = () => {
        this.props.history.replace(SiteRutas.Home);
    }

    onClickBtnSubmit = (event) => {
        event.preventDefault();
        this.cambiarContrasena();  
    }

    cambiarContrasena = async () => {
        const { currentPass, newPass } = this.state;
        const resultado = this.validarDatosForm();
        if (resultado) {
            Notificacion.error(resultado);
        } else {
            const response = await Cambiar_Pin_Request(this.props.token, this.props.login, currentPass, newPass);
            if (response.Exitoso) {
                Notificacion.success("Cambio de PIN exitoso.");  
                //this.props.establecerUsuarioConectado(false);
                this.props.history.replace(SiteRutas.Home);
            }
            else {  
                Notificacion.error(response.Mensaje);
            }
        }
    }

    validarDatosForm = () => {
        const { currentPass, newPass, confirmPass } = this.state;
        if (!this.props.login || !currentPass || !newPass || !confirmPass) {
            return 'Faltan datos para poder continuar con el proceso.';
        }
        if (newPass !== confirmPass) {
            return 'El PIN nuevo no coincide con la confirmación del mismo.';
        }
        return '';
    }

    render() {
        const divStyle = {
            background: 'url(' + ImagenesRutas.Fondo_Login + ') no-repeat center center fixed',
            backgroundSize: 'cover'
        };

        return (
            <div style={divStyle} className="menu_container MainContainer">
                <div className="container">
                    <div className="pull-right">
                        <img className="logo_ld small" src={ImagenesRutas.Logo_LD_Blanco} alt="LogicalDataLogo" />
                    </div>
                    <div className="login_bg">
                        <p className="title">Express Web</p>
                        <h1 className="h1 text-center">Cambiar PIN</h1>
                        <div className="row">
                            <div className="col-12 col-md-10 offset-md-1">
                                <form id="frmCambiarContrasena">
                                    <fieldset>
                                        <legend></legend>
                                        <p>Por favor ingrese sus credenciales para cambiar su PIN.</p>

                                        <div className='form-group'>   
                                            <span className='input-icon'>
                                                <input type='text' className='login' name='user' title='Nombre de Usuario' value={this.props.login} disabled readOnly />
                                            </span>
                                        </div>
                                        <div className='form-group'>
                                            <span className='input-icon'>
                                                <input type='password' className='login' name='currentPass' title='PIN' placeholder='PIN' onChange={this.onChangeInput} />
                                            </span>
                                        </div>
                                        <div className='form-group'>
                                            <span className='input-icon'>
                                                <input type='password' className='login' name='newPass' title='Nuevo Pin' placeholder='Nuevo PIN' onChange={this.onChangeInput} />
                                            </span>
                                        </div>
                                        <div className='form-group'>
                                            <span className='input-icon'>
                                                <input type='password' className='login' name='confirmPass' title='Confirmar Pin' placeholder='Confirmar PIN' onChange={this.onChangeInput} />
                                            </span>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <button type="button" title="Cancelar" className="btn btn-light float-left" onClick={this.onClickBtnCancel}>Cancelar</button>
                                            </div>

                                            <div className="col-6">
                                                <button type="button" title="Cambiar" onClick={this.onClickBtnSubmit} className="btn btn-light float-right">Cambiar</button>
                                            </div>
                                        </div>
                                    </fieldset>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}  
    
const mapStateToProps = state => {
    return {
        token: state.usuario.token,
        login: state.usuario.login,
        activo_AD: state.usuario.activo_AD
    };
};

export default connect(mapStateToProps, { establecerUsuarioConectado })(withRouter(memo(CambiarPinPage)));
